// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"0f9d257d","453":"63aef1d7","455":"6d9b25d5","977":"49eeb80a"}[chunkId] + ".chunk.js";
};